export default __webpack_public_path__ + "static/media/1.d7a0dd63.png";